import { FC } from 'react';

import DepositLayout from 'deposit/components/layouts/deposit-layout';

import RoutesWithNotFound from 'common/config/routes/routesWithNotFound.util';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const DepositRouting: FC<Props> = ({ children }) => {
  return (
    <DepositLayout>
      <RoutesWithNotFound>{children}</RoutesWithNotFound>
    </DepositLayout>
  );
};
export default DepositRouting;
